import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { SaveAndFaxPrivateBillResponse } from "@/Patient/Api/Dto/Responses/SaveAndFaxPrivateBillResponse";
import { SaveAndPrintPrivateBillResponse } from "@/Patient/Api/Dto/Responses/SaveAndPrintPrivateBillResponse";
import { BuildSavePrivateBillRequestHelper } from "@/Patient/Helpers/BuildSavePrivateBillRequestHelper";
import { SaveAndFaxPrivateBillRequestModel } from "@/Patient/Models/Billing/SaveAndFaxPrivateBillRequestModel";
import { SaveAndPrintPrivateBillRequestModel } from "@/Patient/Models/Billing/SaveAndPrintPrivateBillRequestModel";
import { IBillableService } from "@/Patient/Models/UI/History/IBillableService";
import { IPatientPrivateBillModel } from "@/Patient/Models/UI/History/IPatientPrivateBillModel";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PrivateBillActions {
    public async saveAndFaxPrivateBillAsync(
        request: LocalEvent,
        store: PatientStore,
        privateBillModel: IPatientPrivateBillModel,
        billedServices: IBillableService[],
        encounterId: string = "",
        isFromClose: boolean = false
    ): Promise<ClientResponse<SaveAndFaxPrivateBillResponse>> {
        const payload = this.prepareSaveAndFaxPrivateBillRequest(request, store, privateBillModel, billedServices, encounterId, isFromClose);
        return Client.postAsync<SaveAndFaxPrivateBillResponse>(ServerOperations.Server.Myle_PrivateBill_SaveAndFaxPrivateBill, payload);
    }

    public async saveAndPrintPrivateBillAsync(
        request: LocalEvent,
        store: PatientStore,
        privateBillModel: IPatientPrivateBillModel,
        billedServices: IBillableService[],
        encounterId: string = "",
        isFromClose: boolean = false
    ): Promise<ClientResponse<SaveAndPrintPrivateBillResponse>> {
        const payload = this.prepareSaveAndPrintPrivateBillRequest(request, store, privateBillModel, billedServices, encounterId, isFromClose);
        return Client.postAsync<SaveAndPrintPrivateBillResponse>(ServerOperations.Server.Myle_PrivateBill_SaveAndPrintPrivateBill, payload);
    }

    private prepareSaveAndPrintPrivateBillRequest(
        request: LocalEvent,
        store: PatientStore,
        privateBillModel: IPatientPrivateBillModel,
        billedServices: IBillableService[],
        encounterId: string = "",
        isFromClose: boolean = false
    ): SaveAndPrintPrivateBillRequestModel {
        const createdByContactFacetId = sessionStore.getCurrentEmployee().ContactFacetId;
        const patientContactFacetId = store.PatientModels[request.PatientId].InactivableResponse.Id;
        const SavePrivateBillPayload = BuildSavePrivateBillRequestHelper.PrepareRequestData(privateBillModel, patientContactFacetId, isFromClose, createdByContactFacetId, billedServices, encounterId);
        const patientContactId = store.PatientModels[request.PatientId].IndividualResponse?.Contact_id;

        return new SaveAndPrintPrivateBillRequestModel({
            ...SavePrivateBillPayload,
            PatientContactId: patientContactId
        });
    }

    private prepareSaveAndFaxPrivateBillRequest(
        request: LocalEvent,
        store: PatientStore,
        privateBillModel: IPatientPrivateBillModel,
        billedServices: IBillableService[],
        encounterId: string = "",
        isFromClose: boolean = false
    ): SaveAndFaxPrivateBillRequestModel {
        const createdByContactFacetId = sessionStore.getCurrentEmployee().ContactFacetId;
        const patientContactFacetId = store.PatientModels[request.PatientId].InactivableResponse.Id;
        const SavePrivateBillPayload = BuildSavePrivateBillRequestHelper.PrepareRequestData(privateBillModel, patientContactFacetId, isFromClose, createdByContactFacetId, billedServices, encounterId);
        const patientContactId = store.PatientModels[request.PatientId].IndividualResponse?.Contact_id;

        return new SaveAndFaxPrivateBillRequestModel({
            ...SavePrivateBillPayload,
            PatientContactId: patientContactId
        });
    }
}

export { PrivateBillActions };
